module.exports = [
  '$resource',

  function FormResource(
    $resource,
  ) {
    return $resource('/api/v2/groups/:groupId/forms/:id',
      {
        id: '@id',
        groupId: '@groupId',
      },
      {
        get: {
          method: 'GET',
        },
      },
      {
        stripTrailingSlashes: true,
      },
    );
  },
];



// WEBPACK FOOTER //
// ./main/factories/form-resource.js